import React from "react";
import { Wrapper, Container, ButtonWrapper, Image, Title, Description } from "./style";
import { MODAL_MESSAGE } from "store/Modals/constants";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage, closeModal } from "store/Modals/actions";
import { selectModalTitle, selectModalDescription, selectModalImage } from "store/Modals/selectors";
import LabelOnlyButton from "components/commons/Buttons/LabelOnlyButton";
import colors from "styles/colors";

const MessageModal = () => {
  const dispatch = useDispatch();
  const title = useSelector(selectModalTitle);
  const description = useSelector(selectModalDescription);
  const image = useSelector(selectModalImage);

  const onClose = () => {
    dispatch(closeModal(MODAL_MESSAGE));
    dispatch(clearMessage());
  };

  return (
    <Wrapper>
      <Container>
        <Title>{title}</Title>
        <Image src={image} alt="img" />
        <Description>{description}</Description>
        <ButtonWrapper>
          <LabelOnlyButton color={colors.white} background={colors.blue50} border={colors.blue50} onClick={onClose} label="Aceptar" />
        </ButtonWrapper>
      </Container>
    </Wrapper>
  );
};

export default MessageModal;
